export const APP_NAME = 'Trini Rewards' as const;
export const APP_TAGLINE = 'Your opinion. Trini rewards.' as const;
export const APP_SUBTAG = 'T&T OPINION PANEL' as const;
export const POINTS_NAME = 'Trini Points' as const;
export const ONBOARDING_FROM_EMAIL = 'Trini Rewards <onboarding@trinirewards.com>' as const;
export const IMPORT_INVITE_TTL_HOURS = 48 as const;
export const IMPORT_INVITE_TTL_LABEL = '48 hours' as const;
export const FOOTER_ATTRIBUTION =
  'Trini Rewards is operated by CMR Panel LLC, a wholly-owned subsidiary of Caribbean Market Research Limited.' as const;
export const FOOTER_POSTAL_ADDRESS =
  'CMR Panel LLC, 5900 Balcones Dr STE 100, Austin, TX 78731' as const;
